export default __webpack_public_path__ + "static/media/HannahDavison.511eec70.png";